import { useModelContext } from '@app/contexts/model';
import { useStorageContext } from '@app/contexts/storage';
import { MAIN_PAGE } from '@app/enums';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { ModalConfirm } from '@app/modules/Translate/components/ModalConfirmFiles/ModalConfirm';
import { ModalError } from '@app/modules/Translate/components/ModalConfirmFiles/ModalError';
import { ModalSuccess } from '@app/modules/Translate/components/ModalConfirmFiles/ModalSuccess';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IConfirmTranslateProps {}

export const ConfirmTranslate: FunctionComponent<IConfirmTranslateProps> = observer<FunctionComponent<IConfirmTranslateProps>>(function (props) {
    const { translateStore } = useStorageTranslateContext();
    const { langFilesAcceptedModel } = useModelContext();
    const { authorizationModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();
    const { globalStorage } = useStorageContext();

    const user = authorizationModel.user.get();

    let fileToConfirm = confirmTranslateStore.fileId;
    let disabled = !fileToConfirm;

    const onClick = () => {
        if (confirmTranslateStore.fileId && confirmTranslateStore.fileId.length != 2) {
            globalStorage.openModule = MAIN_PAGE.TRANSLATE;
            translateStore.mainLanguageId = '';
            langFilesAcceptedModel.getSelectedToAccept(confirmTranslateStore.acceptedUserId, confirmTranslateStore.languageToAccept).then(
                (v) => {
                    confirmTranslateStore.usersTranslationTarget.set(v.target);
                    confirmTranslateStore.fileId = v.fileId;
                },
                (reason) => console.log('error')
            );
        } else {
            translateStore.handleOpenConfirmModalError();
        }
    };

    return (
        <>
            {user.user.approval && (
                <IconButton disabled={disabled} className='featureButtons__i' aria-hidden='true' title='Confirm translation' onClick={onClick}>
                    <FontAwesomeIcon icon={faCheck} />
                </IconButton>
            )}
            <ModalConfirm />
            <ModalSuccess />
            <ModalError />
        </>
    );
});
